import { Router } from '@angular/router';
import { Component, OnInit } from '@angular/core';

import { ProcessoService } from './../processo/processo.service';
import { BarraProgressoService } from './barra-progresso.service';
import { SessionService } from './../session/session.service';

@Component({
  selector: 'app-barra-progresso',
  templateUrl: './barra-progresso.component.html',
  styleUrls: ['./barra-progresso.component.css']
})
export class BarraProgressoComponent implements OnInit {

  public passoAtual: number;
  public ingresso: string;

  constructor(
    private barraProgressoService: BarraProgressoService,
    private ProcessoService: ProcessoService,
    private SessionService: SessionService,
    private Router: Router,
  ) {
    this.barraProgressoService.barraProgressoEmitter.subscribe(passo => {
      this.passoAtual = passo;
    });
    this.barraProgressoService.nomeProcessoEmitter.subscribe(nome => {
      if (nome) {
        this.ingresso = nome;
      }
    });
  }

  ngOnInit() {
    this.ingresso = this.ProcessoService.getNomeProcesso();
  }

  reiniciaProcesso() {
    let PrcTipPrc = this.SessionService.getValor("PrcTipPrc");
    let Processo = "/" + this.SessionService.getValor("processo");
    this.SessionService.clear();
    this.passoAtual = null;

    if (PrcTipPrc == "M" || PrcTipPrc == "D" || PrcTipPrc == "MD"){
      this.Router.navigate([Processo]);
    }else{
      this.Router.navigate(['/login']);
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/_shared/barra-progresso/barra-progresso.component.ts